import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const TicketsFeature = {
  // Roles that are eligible for the Tickets feature (TX SSO/internal staff only)
  Roles: [
    MccsRoles.ADMINISTRATOR,
    MccsRoles.CHIEF_INVESTIGATOR,
    MccsRoles.INVESTIGATOR,
    MccsRoles.LEGAL,
    MccsRoles.CREDENTIALING,
    MccsRoles.CREDENTIALING_ADMIN,
  ],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(TicketsFeature.Roles, user),

  // Can create tickets
  CreateRoles: [
    MccsRoles.ADMINISTRATOR,
    MccsRoles.CREDENTIALING,
    MccsRoles.CREDENTIALING_ADMIN,
  ],
  Create: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(TicketsFeature.CreateRoles, user),
  } satisfies Feature,

  // Can respond to or reassign tickets
  ManageRoles: [
    MccsRoles.CREDENTIALING_ADMIN,
    MccsRoles.CREDENTIALING,
    MccsRoles.CHIEF_INVESTIGATOR,
    MccsRoles.INVESTIGATOR,
    MccsRoles.LEGAL,
  ],
  Manage: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(TicketsFeature.ManageRoles, user),
  } satisfies Feature,

  // Can categorize tickets
  Categorize: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(TicketsFeature.ManageRoles, user),
  } satisfies Feature,
} satisfies Feature
